import { render } from "./DifferentialLiberationSection.vue?vue&type=template&id=27039f68"
import script from "./DifferentialLiberationSection.vue?vue&type=script&lang=js"
export * from "./DifferentialLiberationSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__